import "../../vendor/sienna-vpnmentor.min";
import $ from 'cash-dom';

$(function () {
	const $showAccessibilityButton = $('#show-accessibility-button');

	if ($showAccessibilityButton.length) {

		// Sienna only inits from a `readystatechange` listener it registers on load. We require it
		// lazily, after DOM ready, so on a fast load "complete" has already fired and it would wait
		// forever. Re-dispatch only in that case; otherwise it still catches the real event.
		if (document.readyState === 'complete') {
			document.dispatchEvent(new Event('readystatechange'));
		}
	}

	// wizcase holds the button back while the header with the burger is still on screen; the class only
	// hides it at the burger widths (see _accessibility-widget.scss). A header without the burger (PPC
	// pages, a page that hides the main nav) leaves the button where it is.
	const header = document.getElementById('site-header');
	const hasBurger = header && header.querySelector('#wc-nav-toggle');

	if (document.body.dataset.parentWebsiteId === 'wizcase' && hasBurger && 'IntersectionObserver' in window) {
		document.body.classList.add('asw-under-header');

		new IntersectionObserver(([entry]) => {
			document.body.classList.toggle('asw-under-header', entry.isIntersecting);
		}).observe(header);
	}

	// we use setInterval() because the button is not on page immediately
	const intervalId = setInterval(() => {
		const $accessibilityWidgetButton = $('.asw-widget .asw-menu-btn');

		if ($accessibilityWidgetButton.length) {
			$accessibilityWidgetButton.attr('data-btn-name', 'accessibility-widget');
			clearInterval(intervalId);

			// this build renders its menu before it reads <html lang>, so the menu always starts in English;
			// a language it has no translation for stays English
			const lang = (document.documentElement.lang || '').split('-')[0];
			const select = document.getElementById('asw-language');

			if (select && select.value !== lang && select.querySelector(`option[value="${lang}"]`)) {
				select.value = lang;
				select.dispatchEvent(new Event('change'));
			}
		}
	}, 50);

    const $aswBtn2 = $('#asw_menu_btn2');
    if ($aswBtn2.length) {
        $aswBtn2.on('click', (e) => {
            e.preventDefault();

            $('.refine-button-box').hide();
            $('.asw-widget .asw-menu-btn').trigger('click');
        });
    }
});
